import $ from 'jquery';


$(window).on('scroll', function () {
    if($(window).scrollTop() > 400) {
        $('.header').height($('.header').height());
        $('.header__bottom').addClass('header__bottom--fixed');
    } else {
        $('.header__bottom').removeClass('header__bottom--fixed');
        $('.header').removeAttr('style');
    }

    if($(window).scrollTop() > 400 && $(window).scrollTop() <= 600 && $(window).width() > 1340) {
        $('.navigation__list-wrap').removeClass('navigation__list-wrap--show');
        $('.navigation__link').removeClass('navigation__link--active');
    }

    if($(window).scrollTop() > 600) {
        $('.header__bottom').addClass('header__bottom--show');
    } else {
        $('.header__bottom').removeClass('header__bottom--show');
    }
})